/**
 * پشتِ کارتِ خودم سرِ میزِ وب — همان `CardBack.CurKey` ِ اپ.
 *
 * تا ۱۹ اکتبرِ ۲۰۲۶ هر ورقِ پشت‌وروی وب از یک فایلِ ثابت (`/art/table/back.webp`)
 * کشیده می‌شد. «به‌کار ببند» در فروشگاه انتخاب را در سرور می‌نشاند و هیچ میزی
 * آن را نمی‌خواند: بازیکن گوهر می‌داد، «به‌کار بسته» می‌دید، و سرِ میز همان
 * ترنجِ نیلیِ پیش‌فرض را.
 *
 * قاعده همان اپ است: پشتی که خودم به‌کار بسته‌ام روی **همه‌ی** ورق‌های پشت‌رویی
 * که می‌بینم — دسته، دستِ حریف، پخش. انتخاب از `client.back` می‌آید (پاسخِ ورود
 * و «به‌کار ببند»)، و این‌جا فقط به متغیرِ `--card-back` و کلاسِ `myback` روی
 * <html> ترجمه می‌شود؛ CSS بقیه را می‌کشد.
 *
 * آرت همان تصویرِ فروشگاه است (`/art/shop/<شناسه>.webp`، ۳۰۰×۴۳۵، هم‌نسبتِ ورق).
 * کلاس فقط **بعد از رسیدنِ تصویر** می‌نشیند: تصویری که نرسد ورقِ شفاف نمی‌سازد،
 * پشتِ پیش‌فرض می‌ماند.
 */

const ID = /^card_back_[a-z0-9_]+$/;

/** نشانیِ آرتِ این پشت در وب، یا خالی برای پیش‌فرض و شناسه‌ی ناشناخته. */
export function backArt(id: string): string {
  return ID.test(id) ? `/art/shop/${id}.webp` : "";
}

let wanted = "";
let personal = "";
let tableBack = "";

/**
 * پشتِ کارتِ **میز** — «میزهای من» (۲۱ اکتبر ۲۰۲۶): میزی که مشتری ساخته پشتِ کارت هم دارد و همه‌ی
 * سرِ همان میز ورق‌های پشت‌رو را با آن می‌بینند؛ تا وقتی سرِ آن میزیم بر پشتِ خودم می‌چربد. کلیدِ
 * میز آن را با «@» می‌آورد (game/carpet.ts، showCarpet). خالی = پشتِ خودم.
 */
export function setTableBack(id: string, root: HTMLElement = document.documentElement): void {
  tableBack = ID.test(id) ? id : "";
  render(tableBack || personal, root);
}

/**
 * پشتِ <paramref name="id"/> را روی میز بنشان. خالی = پیش‌فرض.
 *
 * تصویر اول بار می‌شود و بعد سوییچ می‌کند؛ اگر در این میان انتخابِ دیگری آمد،
 * جوابِ کهنه نادیده می‌ماند. پشتِ میز ([[setTableBack]]) اگر باشد بر این می‌چربد.
 */
export function applyCardBack(id: string, root: HTMLElement = document.documentElement): void {
  personal = id;
  render(tableBack || personal, root);
}

function render(id: string, root: HTMLElement): void {
  const src = backArt(id);
  wanted = src;
  if (!src) {
    root.classList.remove("myback");
    root.style.removeProperty("--card-back");
    return;
  }
  const img = new Image();
  img.onload = () => {
    if (wanted !== src) return;
    root.style.setProperty("--card-back", `url("${src}")`);
    root.classList.add("myback");
  };
  img.onerror = () => {
    if (wanted !== src) return;
    root.classList.remove("myback");
    root.style.removeProperty("--card-back");
  };
  img.src = src;
}
